import {login} from "@/api/user";
import md5 from "js-md5";

export default {
  data() {
    return {};
  },
  mounted() {
    if (sessionStorage.getItem("token")) {
      this.getData && this.getData();
      return;
    }
    const tenantId = "946139";
    const username = "admin";
    const password = md5("admin@Hnac2023");
    login({
      tenantId,
      username,
      password,
      grant_type: "password",
      scope: "all",
      type: "account",
    }).then((res) => {
      sessionStorage.setItem("tenantId", res.data.tenant_id);
      sessionStorage.setItem("token", res.data.access_token);
      sessionStorage.setItem("userInfo", JSON.stringify(res.data));

      this.getData && this.getData();
    });
  },
};
